module.exports = __webpack_public_path__ + "img/notification-oops.805d0c3e.svg";